<template>

    <div class="flex w-full lg:w-1/2 xl:1/2 flex-col min-w-0 overflow-hidden">
      <div class="lg:hidden">

        <div class="flex items-center justify-between bg-gray-50 lg:bg-transparent border-b border-gray-200 lg:border-0 px-4 lg:px-6 xl:px-12 py-1.5">
          <div class="flex items-center flex-shrink-0 xl:mt-12 font-bold text-lg">
            poseXR
          </div>
          <div>
            <button type="button" class="-mr-3 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900">
              <span class="sr-only">Open sidebar</span>
              <i class="fas fa-bars"></i>
            </button>
          </div>
        </div>

      </div>

      <div class="flex-1 relative z-0 flex overflow-hidden">

        <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none xl:order-last" tabindex="0">
          <!-- Start main area-->
          <div class="absolute inset-0">
            <div class="flex justify-center rounded-lg aspect-w-9 aspect-h-16 relative">
              <iframe src="https://portal.furioos.com/embed/165.644" allowfullscreen="true" style="border: none;" class="lg:rounded-lg"></iframe>
            </div>
          </div>
          <!-- End main area -->
        </main>

      </div>

      <!-- Mobile Nav -->
      <div class="lg:hidden">
            <div class="bg-white absolute bottom-0 w-full">

              <!-- <div class="h-full flex flex-1 flex-col py-6 bg-gray-200 border-t-2 border-gray-300 overflow-y-scroll">
                <div class="px-4 sm:px-12">
                  <div class="flex items-start justify-between">
                    <h2 id="slide-over-heading" class="text-lg font-medium text-gray-900">
                      Options
                    </h2>
                    <div class="ml-3 h-7 flex items-center">
                      <button class="bg-gray-200 rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <span class="sr-only">Close panel</span>
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="mt-6 relative flex-1 px-4 sm:px-6">
                  <div class="absolute inset-0 px-4 sm:px-12">
                    <div class="h-full border-2 border-dashed border-gray-200" aria-hidden="true"></div>
                  </div>
                </div>
              </div> -->


              <div class="border-b border-gray-200">
                <nav class="-mb-px flex" aria-label="Tabs">
                  <!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
                  <a href="#" class="border-indigo-500 text-indigo-600 w-1/5 py-4 px-1 text-center border-t-2 font-medium text-sm" aria-current="page">
                    Looks
                  </a>
                  <a href="#" class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/5 py-4 px-1 text-center border-t-2 font-medium text-sm">
                    Scene
                  </a>
                  <a href="#" class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/5 py-4 px-1 text-center border-t-2 font-medium text-sm">
                    Lighting
                  </a>
                  <a href="#" class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/5 py-4 px-1 text-center border-t-2 font-medium text-sm">
                    Props
                  </a>
                  <a href="#" class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/5 py-4 px-1 text-center border-t-2 font-medium text-sm">
                    Music
                  </a>
                </nav>
              </div>

              <!-- <div class="relative bottom-0 w-full lg:bg-white flex-shrink-0 flex lg:border-t border-gray-200 py-6 px-12">
                <a href="#" class="flex-shrink-0 w-full group block">
                  <div class="flex items-center justify-center">
                    <button type="button" class="flex items-center justify-center px-6 py-3 border border-transparent text-base text-center font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                      Capture
                    </button>
                  </div>
                </a>
              </div> -->

            </div>
      </div>

      </div>


</template>

<script>
export default {
  name: 'alt'
}
</script>
